
import './App.css';

import Clock from './Clock.js';


function App() {
  return (
    <>
    <Clock />
    </>
  );
}

export default App;
